import { useState } from "react";
import { supabase } from "../supabase";
import { B } from "../constants";

export default function ResetPassword({ onComplete }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    const { error: updateErr } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (updateErr) { setError(updateErr.message); return; }
    onComplete();
  };

  return (
    <div style={{minHeight:"100vh",background:B.bg,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:24,fontFamily:"IBM Plex Mono,monospace"}}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500;600&family=IBM+Plex+Sans:wght@400;500&display=swap');*{box-sizing:border-box;margin:0;padding:0}input::placeholder{color:${B.muted}}`}</style>
      <div style={{marginBottom:32,textAlign:"center"}}>
        <div style={{fontSize:11,letterSpacing:"0.2em",color:B.accent,textTransform:"uppercase",fontWeight:600,marginBottom:8}}>FYNWELL</div>
        <h1 style={{fontSize:22,fontWeight:600,color:B.text,margin:0}}>Set New Password</h1>
      </div>
      <form onSubmit={submit} aria-label="Set new password" style={{width:"100%",maxWidth:320,display:"flex",flexDirection:"column",gap:12}}>
        <label htmlFor="reset-password" style={{position:"absolute",width:1,height:1,overflow:"hidden",clip:"rect(0,0,0,0)"}}>New password</label>
        <input
          id="reset-password" type="password" placeholder="New password" value={password} onChange={e=>setPassword(e.target.value)} required minLength={6} autoComplete="new-password" autoFocus
          style={{padding:"12px 14px",borderRadius:10,border:`1px solid ${B.border}`,background:"rgba(255,255,255,0.04)",color:B.text,fontSize:13,fontFamily:"IBM Plex Sans,sans-serif"}}
        />
        <label htmlFor="reset-confirm" style={{position:"absolute",width:1,height:1,overflow:"hidden",clip:"rect(0,0,0,0)"}}>Confirm password</label>
        <input
          id="reset-confirm" type="password" placeholder="Confirm password" value={confirm} onChange={e=>setConfirm(e.target.value)} required minLength={6} autoComplete="new-password"
          style={{padding:"12px 14px",borderRadius:10,border:`1px solid ${B.border}`,background:"rgba(255,255,255,0.04)",color:B.text,fontSize:13,fontFamily:"IBM Plex Sans,sans-serif"}}
        />
        <button type="submit" disabled={loading}
          style={{padding:"12px 14px",borderRadius:10,border:"none",background:B.accent,color:"#0A0E14",fontSize:13,fontWeight:600,cursor:loading?"wait":"pointer",fontFamily:"IBM Plex Mono,monospace",opacity:loading?0.7:1}}>
          {loading?"Updating...":"Update Password"}
        </button>
        {error&&<div role="alert" style={{fontSize:12,color:B.red,textAlign:"center"}}>{error}</div>}
      </form>
    </div>
  );
}
